import React, { useState, useId } from 'react';

const Tooltip = ({ text, children, position = 'top', wrap = false, wide = false, extraWide = false }) => {
  const [isVisible, setIsVisible] = useState(false);
  const tooltipId = useId();

  const positionClasses = {
    top: 'bottom-full left-1/2 transform -translate-x-1/2 mb-2',
    bottom: 'top-full left-1/2 transform -translate-x-1/2 mt-2',
    left: 'right-full top-1/2 transform -translate-y-1/2 mr-2',
    right: 'left-full top-1/2 transform -translate-y-1/2 ml-2'
  };

  const wrapWidthClass = extraWide ? 'max-w-7xl' : (wide ? 'max-w-6xl' : 'max-w-4xl');
  const textClasses = wrap
    ? `bg-gray-800 text-white text-sm rounded-lg py-3 px-4 whitespace-normal shadow-lg ${wrapWidthClass}`
    : 'bg-gray-800 text-white text-xs rounded py-1 px-2 whitespace-nowrap';

  return (
    <div
      className="relative inline-block"
      onMouseEnter={() => setIsVisible(true)}
      onMouseLeave={() => setIsVisible(false)}
      onFocus={() => setIsVisible(true)}
      onBlur={() => setIsVisible(false)}
    >
      {React.cloneElement(React.Children.only(children), {
        'aria-describedby': isVisible ? tooltipId : undefined,
      })}
      {isVisible && (
        <div className={`absolute z-20 ${positionClasses[position]}`}>
          <div id={tooltipId} role="tooltip" className={textClasses}>
            {text}
          </div>
        </div>
      )}
    </div>
  );
};

export default Tooltip;
